<template>
    <div class="link-container">
        <div class="left-item">
            <i class="el-icon-paperclip icon"></i>
        </div>
        <div class="right-item">
            <span class="title">
                <span v-if="!$scopedSlots.title">
                    {{title}}
                </span>
                <slot name="title" v-else></slot>
            </span>
            <div class="sub-title">
                <span>{{subTitle}}</span>
                <div class="links">
                    <slot name="links"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LinkContainer",
        props: {
            title: String,
            subTitle: String,
        },

    }
</script>

<style scoped>
    .link-container {
        border: 1px solid rgb(0, 153, 255);
        border-radius: 1px;
        padding: 8px;
        display: flex;
        flex-direction: row;
    }
    .link-container .left-item {
        width: 44px;
        height: 44px;
        border: 1px solid rgb(0, 153, 255);
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
    }
    .link-container .left-item .icon {
        color: rgb(0, 153, 255);
        font-size: 34px;
    }
    .link-container .right-item {
        flex: 1;
        font-size: 14px;
        margin-left: 8px;
        line-height: 22px;
        /*width: calc(100% - 60px);*/
        text-overflow: ellipsis;
        overflow-x: hidden;
    }
    .link-container .right-item .title {
        font-weight: bold;
    }

    .link-container .right-item .sub-title {
        font-size: 12px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .link-container .right-item .sub-title .links {

    }
    .link-container .right-item .sub-title .links .el-link {
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/container/LinkContainer.vue